import React from 'react';
import { Navbar11 } from '../../blog/components/Navbar11';
import { Footer } from '../../components/shared/Footer';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar11 />
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto prose prose-invert">
          <h1 className="text-4xl font-bold mb-8">Cookie Policy</h1>
          <p className="text-lg mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. What Are Cookies</h2>
            <p>
              Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide a better browsing experience.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. How We Use Cookies</h2>
            <p>We use cookies for the following purposes:</p>
            <ul>
              <li>
                <strong>Essential Cookies:</strong> These cookies are necessary for the website to function properly and cannot be switched off in our systems.
              </li>
              <li>
                <strong>Analytics Cookies:</strong> These help us analyze how visitors use our website, allowing us to improve our services.
              </li>
              <li>
                <strong>Functional Cookies:</strong> These cookies enable enhanced functionality and personalization.
              </li>
              <li>
                <strong>Marketing Cookies:</strong> These cookies may be set by our advertising partners to build a profile of your interests.
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Types of Cookies We Use</h2>
            <h3 className="text-xl font-semibold mb-3">3.1 First-Party Cookies</h3>
            <p>Cookies set by Omnigeist:</p>
            <ul>
              <li>Session cookies for website functionality</li>
              <li>User preference cookies</li>
              <li>Authentication cookies</li>
            </ul>

            <h3 className="text-xl font-semibold mb-3 mt-6">3.2 Third-Party Cookies</h3>
            <p>Cookies set by our partners:</p>
            <ul>
              <li>Google Analytics for website analytics</li>
              <li>Social media plugins</li>
              <li>Marketing and advertising cookies</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Managing Cookies</h2>
            <p>
              Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may impact your overall user experience.
            </p>
            <p className="mt-4">To manage cookies in your browser:</p>
            <ul>
              <li>Chrome: Settings → Privacy and Security → Cookies and other site data</li>
              <li>Firefox: Options → Privacy & Security → Cookies and Site Data</li>
              <li>Safari: Preferences → Privacy → Cookies and website data</li>
              <li>Edge: Settings → Privacy, search, and services → Cookies</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Your Choices</h2>
            <p>You have the following options regarding cookies on our website:</p>
            <ul>
              <li>Accept all cookies</li>
              <li>Only accept essential cookies</li>
              <li>Reject all cookies (may affect website functionality)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
            <p>
              If you have any questions about our Cookie Policy, please contact us at:
              <br />
              Email: privacy@omnigeist.com
              <br />
              Address: [Your Business Address]
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
